<p>{{message}}</p>
<!-- <button (click)="logout()">Logout</button> -->